enum PermissionType {
    ForAssistants = 1,
    ForPracticians = 2,
    ForEmployees = 3,
    ForAdmins = 4,
    ForApi = 8
}

export { PermissionType };
